/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, useEffect, useState } from "react";
// import "./Verify.css";
import ButtonCustom from "../../components/button/ButtonCustom";
import qs from "qs";
import axios from "axios";
import Loading from "../../components/loading/loading";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { config } from "./../../constants";
import { popupErrorApi } from "../../components/helpers/Helpers";
import { isMobile } from "react-device-detect";
import BannerContentLeft from "../../components/BannerContentLeft/BannerContentLeft";
import { Wrapper, CardList } from "../../components/NDID2";
import { Grid, Typography, RadioGroup, FormControl } from "@mui/material";
import _ from "lodash";


const EkycList = (props) => {
  const HeaderManp = JSON.parse(localStorage.getItem("HeaderManp"));
  const [loading, setIsLoading] = useState(false);
  const [value, setValue] = useState("");
  const [channelList, setChannelList] = useState([]);
  const [channelID, setChannelID] = useState([]);

  const goBack = () => {
    props.history.push("/product_choice");
  }

  const sendData = (e) => {
    e.preventDefault();
    saveComeBack()

  };

  useEffect(() => {
    setIsLoading(true)
    axios
      .get(`${config.baseAPIURL03}/constant/ekyc_channel?personflag=${"T"}`)
      .then((res) => {
        const ListChanel = res.data.Data;
        setChannelList(setSort(ListChanel))
        setIsLoading(false)

      })
      .catch((error) => {
        setIsLoading(false)
        var mss = "";
        var title_mss = "";
        if (!!error.isAxiosError && !error.response) {
          title_mss = "เกิดข้อผิดพลาด";
          mss = "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
        } else {
          title_mss =
            error.response.data.Data !== undefined &&
              error.response.data.Data[0][0].MsgDescTitle !== ""
              ? error.response.data.Data[0][0].MsgDescTitle
              : "เกิดข้อผิดพลาด";
          mss =
            error.response.data.Data !== undefined &&
              error.response.data.Data[0][0].MsgDesc !== ""
              ? error.response.data.Data[0][0].MsgDesc
              : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
        }
        popupErrorApi(mss, title_mss, true);
      });
  }, []);
  const setSort = (data) => {
    const key = "verification_Th";
    const transformWithKey = transformData(key);
    return transformWithKey(data)
  };
  const transformData = (key) => (banks) => {
    const sortedData = _.sortBy(banks, key);
    return sortedData.map((verification) => ({
      value: verification.verification_Code,
      logo: verification.verification_logo,
      name: verification[key],
      appName: verification.verification_Code,
    }));
  };

  const saveComeBack = async () => {
    setIsLoading(true);
    const channelID = value;
    const HeaderManp = JSON.parse(localStorage.getItem("HeaderManp"));
    const { head_token } = HeaderManp;
    var last_stamp = JSON.stringify(allStorage());
    var title_mss = "";
    var mss = "";
    const ops = {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Accept: "application/json",
      },
      data: {
        last_stamp: last_stamp,
        head_token: head_token,
        stamp_page: channelID === "DIPCHIP" ? "DIPCHIP" : channelID === "NDID" ? "NDID" : "",
      },
      url: config.baseAPIURL03 + "/form/comeback/manp",
    };
  
    await axios(ops)
      .then(async (res) => {
        setIsLoading(false);
        let keys = Object.keys(localStorage),
          i = keys.length;
        while (i--) {
          // console.log(i, keys[i]);
        }

        if (channelID === "DIPCHIP" || channelID === "ThaiID") {
          localStorage.setItem("currentStep", "dipchip_waiting");
          props.history.push("/dipchip_waiting/");
        } else if (channelID === "NDID") {
          localStorage.setItem("currentStep", "ndid_info");
          props.history.push("/ndid_info");
        }
      })
      .catch((error) => {
        if (!!error.isAxiosError && !error.response) {
          title_mss = "เกิดข้อผิดพลาด";
          mss = "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
        } else {
          title_mss =
            error.response.data.Data[0][0].MsgDescTitle !== ""
              ? error.response.data.Data[0][0].MsgDescTitle
              : "เกิดข้อผิดพลาด";
          mss =
            error.response.data.Data[0][0].MsgDesc !== ""
              ? error.response.data.Data[0][0].MsgDesc
              : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
        }
        popupErrorApi(mss, title_mss);
        setIsLoading(false);
        return;
      });
  };
  const allStorage = () => {
    let values = [],
      keys = Object.keys(localStorage),
      i = keys.length;
    while (i--) {
      if (keys[i].indexOf("debug") !== -1) {
      } else {
        values.push({
          key: keys[i],
          value:
            keys[i] === "currentStep"
              ? "tc_ndid"
              : localStorage.getItem(keys[i]),
        });
      }
    }
    return values;
  };
  return (
    <div className={isMobile ? "" : "body"}>
      <header
        className={isMobile ? "" : "header-area"}
        style={{ display: isMobile ? "none" : "block" }}
      >
        <div className={"container everest-nav-container"}>
          <div className={"row"}>
            <div className={"col-md-6"}>
              <img src="../../../images/logo.png" />
            </div>
            <div className={"col-md-6 flex_end"}>
              <div className="text-branding">บริการเปิดบัญชีออนไลน์</div>
            </div>
          </div>
        </div>
      </header>
      <section
        className={isMobile ? "" : "desktop_content section-gap-full"}
        style={{
          backgroundImage: isMobile ? "none" : "url(/images/bg.jpg)",
        }}
      >
        <div className={isMobile ? "" : "container"}>
          <div className={isMobile ? "" : "row"}>
            <div
              className={"col-md-6"}
              style={{ display: isMobile ? "none" : "block" }}
            >
              <BannerContentLeft></BannerContentLeft>
            </div>
            <div className={isMobile ? "" : "col-md-6"}>
              {/* content mobile */}
              <div>
                <Loading status={loading} />
                <div className="content">
                  <div className="top_main_back">
                    <div className="main_back" onClick={goBack}>
                      <img
                        src={
                          isMobile
                            ? "/images/angle-arrow-left.svg"
                            : "/images/angle-arrow-left-blue.svg"
                        }
                        style={{ marginLeft: "3px" }}
                        className="arrow_back"
                      />
                    </div>
                    <div className="text_title">
                      เลือกวิธีการยืนยันตัวตน
                    </div>
                  </div>

                  <div
                    className="bg_content_white over_f_hide"
                    style={{ padding: "0" }}
                  >
                    <div
                      className="in_bg_white autoscroll"
                      style={{ top: 0, left: 0, right: 0 }}
                    >
                      <Wrapper
                        content={
                          <Grid id="banks" container style={{ justifyContent: "center" }}>
                            <FormControl>
                              <RadioGroup
                                name="bank-list"
                                value={value}
                                onChange={(e) => setValue(e.target.value)}
                              >
                                {/* {isThereEnroll && (
                                <CardList
                                  label="เลือกผู้ให้บริการ NDID ที่ท่านได้ลงทะเบียนไว้"
                                  data={dataList.enroll}
                                />
                              )} */}

                                <CardList
                                  data={channelList}
                                />

                              </RadioGroup>
                            </FormControl>
                          </Grid>
                        }
                      />
                    </div>
                    <div className="under_fix_btn">
                      <ButtonCustom
                        handle={
                          value === "" ? null : sendData
                        }
                        label="ถัดไป"
                        color={value === "" ? "gray" : "blue"}
                        btnClass="long_btn"
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* end content mobile */}
            </div>
          </div>
        </div>
      </section>
    </div>
  );

}

export default EkycList;
